import { render, staticRenderFns } from "./WelcomeFooter.vue?vue&type=template&id=25604ac9"
import script from "./WelcomeFooter.vue?vue&type=script&lang=js"
export * from "./WelcomeFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports